/**
 * Crea los Mensajes del panel
 * @param {*} scene 
 */
export function crearMensajesPanel(scene) {
  /*/=======================================================================================\*\
  ||                                        CARTELES JUGADOR 1                               ||
  \*\=======================================================================================/*/
  scene.mensajePanelPagarSeguro = scene.add.image(392, 450, "mensajePanelPagarSeguro");
  scene.mensajePanelPagarSeguro.setDepth(300);
  scene.mensajePanelPagarSeguro.setVisible(false);
  
}